// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dt7Y","badges":"styles_badges__1-_kM"};